// extracted by mini-css-extract-plugin
export default {"beanInfoHeader":"BeanInfoCard_beanInfoHeader__i2U6y","beanInfoRow":"BeanInfoCard_beanInfoRow__h5gOY","beanInfoRowText":"BeanInfoCard_beanInfoRowText__cFj1W"};